import React from "react";
import MuiLink from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";

type CprimeLinkProps = React.ComponentProps<typeof MuiLink> & {
  to?: string;
};

const CprimeLink: React.FC<CprimeLinkProps> = ({
  to,
  sx,
  underline = "hover",
  color = "inherit",
  ...props
}) => {
  if (to) {
    return (
      <MuiLink
        {...(props as any)}
        component={RouterLink as any}
        to={to}
        underline={underline}
        color={color}
        sx={{
          fontFamily: "ToyotaType-Regular",
          ...sx,
        }}
      />
    );
  }

  return (
    <MuiLink
      {...props}
      underline={underline}
      color={color}
      sx={{
        fontFamily: "ToyotaType-Regular",
        ...sx,
      }}
    />
  );
};

export default CprimeLink;
